export enum TransmissionType {
    Automatic = "1", 
    Manual = "2"
}